import { Component, OnInit, Input } from '@angular/core';
import { Formulario } from 'src/app/models';

@Component({
    selector: 'app-consulta-nd',
    templateUrl: 'no-dependientes.component.html',
    styleUrls: ['no-dependientes.component.scss']
})
export class ConsultaNDComponent implements OnInit {
  @Input() formulario: Formulario;

  constructor() {  }
    ngOnInit() { }

}
